/* eslint-disable react-hooks/exhaustive-deps */
import React from "react";
import ShelveLocationTab from "./_components/ShelveLocationTab";
const ShelveManagement: React.FC = () => {
  return <ShelveLocationTab />;
};

export default ShelveManagement;
